import React, { useState } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";

const PersonalDetails = () => {
  const [isEdit, setIsEdit] = useState(true);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      dateOfBirth: "",
      gender: "Female",
      contactNumber: "",
      emailAddress: "",
      countryOfBirth: "",
      placeOfBirth: "",
      aNumber: "",
      countryOfCitizenship: "",
      currentLocation: "USA",
      nonImmigrantStatus: "",
      eadNumber: "",
      sevisNumber: "",
      workAuthorization: "",
      address1: "",
      address2: "",
      country: "",
      state: "",
      city: "",
      zipcode: "",
      //   foreignAddress1: "",
      secondAddress1: "",
      secondAddress2: "",
      secondCountry: "",
      secondState: "",
      secondCity: "",
      secondZipcode: "",
    },
    {
      dateOfBirth: { type: "datepicker", required: true },
    },
  );

  return (
    <div>
      <div className="my-3">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"PERSONAL DETAILS"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button title="Edit" size="sm" onClick={() => setIsEdit(false)} />
            </>
          }
        />
        <Divider />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 mt-8 gap-x-8 gap-y-6">
        <FormFieldSet
          type="select"
          title={"Date of Birth"}
          placeholder="Select Date of Birth"
          value={formData.dateOfBirth}
          onChange={(value) => handleChange("dateOfBirth", value)}
          error={errors.dateOfBirth}
          disabled={isEdit}
        />
        <FormFieldSet
          type="radio"
          title={"Gender"}
          value={formData.gender}
          options={[
            {
              label: "Male",
              value: "Male",
            },
            { label: "Female", value: "Female" },
          ]}
          onChange={(event) => handleChange("gender", event.target.value)}
          error={errors.gender}
          name="Gender"
          disabled={isEdit}
        />
        <FormFieldSet
          type="phone"
          title={"Contact Number"}
          placeholder="Enter Contact Number"
          value={formData.contactNumber}
          onChange={(value) => handleChange("contactNumber", value)}
          error={errors.contactNumber}
          disabled={isEdit}
        />
        <FormFieldSet
          type="text"
          title={"Email Address"}
          placeholder="Enter Email Address"
          value={formData.emailAddress}
          onChange={(value) => handleChange("emailAddress", value)}
          error={errors.emailAddress}
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title={"Country of Birth"}
          placeholder="Select Country of Birth"
          value={formData.countryOfBirth}
          onChange={(value) => handleChange("countryOfBirth", value)}
          error={errors.countryOfBirth}
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title={"Place of Birth"}
          placeholder="Enter Place of Birth"
          value={formData.placeOfBirth}
          onChange={(value) => handleChange("placeOfBirth", value)}
          error={errors.placeOfBirth}
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title={"A-Number"}
          placeholder="Enter A-Number"
          value={formData.aNumber}
          onChange={(value) => handleChange("aNumber", value)}
          error={errors.aNumber}
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title={"Country of Citizenship"}
          placeholder="Select Country of Citizenship"
          value={formData.countryOfCitizenship}
          onChange={(value) => handleChange("countryOfCitizenship", value)}
          error={errors.countryOfCitizenship}
          disabled={isEdit}
        />
        <FormFieldSet
          type="radio"
          title={"Current Location"}
          options={[
            {
              label: "USA",
              value: "USA",
            },
            { label: "Outside", value: "Outside" },
          ]}
          value={formData.currentLocation}
          onChange={(event) =>
            handleChange("currentLocation", event.target.value)
          }
          error={errors.currentLocation}
          name="USA"
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title={"Non Immigrant status"}
          placeholder="Select Non Immigrant status"
          value={formData.nonImmigrantStatus}
          onChange={(value) => handleChange("nonImmigrantStatus", value)}
          error={errors.nonImmigrantStatus}
          disabled={isEdit}
        />
        <FormFieldSet
          type="text"
          title={"EAD Number"}
          placeholder="Enter EAD Number"
          value={formData.eadNumber}
          onChange={(value) => handleChange("eadNumber", value)}
          error={errors.eadNumber}
          disabled={isEdit}
        />
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-3 mt-8 2xl:grid-cols-4 gap-x-8 gap-y-6">
        <FormFieldSet
          type="text"
          title={"SEVIS Number"}
          placeholder="Enter SEVIS Number"
          value={formData.sevisNumber}
          onChange={(value) => handleChange("sevisNumber", value)}
          error={errors.sevisNumber}
          disabled={isEdit}
        />
        <FormFieldSet
          type="select"
          title={"Work Authorization"}
          placeholder="Select Work Authorization"
          value={formData.workAuthorization}
          onChange={(value) => handleChange("workAuthorization", value)}
          error={errors.workAuthorization}
          disabled={isEdit}
        />
      </div>
      <div>
        <div className="flex mt-4">
          <PageTitle title={"ADDRESS DETAILS"} tag="p" />
        </div>
        <Divider />
        <h6 className="my-4">Current USA Address</h6>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-8 gap-y-6">
          <FormFieldSet
            type="text"
            title={"Address 1"}
            placeholder="Enter Address 1"
            value={formData.address1}
            onChange={(value) => handleChange("address1", value)}
            error={errors.address1}
            disabled={isEdit}
          />
          <FormFieldSet
            type="text"
            title={"Address 2"}
            placeholder="Enter Address 2"
            value={formData.address2}
            onChange={(value) => handleChange("address2", value)}
            error={errors.address2}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"Country"}
            placeholder="Select Country"
            value={formData.country}
            onChange={(value) => handleChange("country", value)}
            error={errors.country}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"State"}
            placeholder="Select State"
            value={formData.state}
            onChange={(value) => handleChange("state", value)}
            error={errors.state}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"City"}
            placeholder="Select City"
            value={formData.city}
            onChange={(value) => handleChange("city", value)}
            error={errors.city}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"Zipcode"}
            placeholder="Select Zipcode"
            value={formData.zipcode}
            onChange={(value) => handleChange("zipcode", value)}
            error={errors.zipcode}
            disabled={isEdit}
          />
          <div className="col-span-2 xl:col-span-3">
            <h6>Foreign Address</h6>
          </div>
          <FormFieldSet
            type="text"
            title={"Address 1"}
            placeholder="Enter Address 1"
            value={formData.secondAddress1}
            onChange={(value) => handleChange("secondAddress1", value)}
            error={errors.secondAddress1}
            disabled={isEdit}
          />
          <FormFieldSet
            type="text"
            title={"Address 2"}
            placeholder="Enter Address 2"
            value={formData.secondAddress2}
            onChange={(value) => handleChange("secondAddress2", value)}
            error={errors.secondAddress2}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"Country"}
            placeholder="Select Country"
            value={formData.secondCountry}
            onChange={(value) => handleChange("secondCountry", value)}
            error={errors.secondCountry}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"State"}
            placeholder="Select State"
            value={formData.secondState}
            onChange={(value) => handleChange("secondState", value)}
            error={errors.secondState}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"City"}
            placeholder="Select City"
            value={formData.secondCity}
            onChange={(value) => handleChange("secondCity", value)}
            error={errors.secondCity}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"Zipcode"}
            placeholder="Select Zipcode"
            value={formData.secondZipcode}
            onChange={(value) => handleChange("secondZipcode", value)}
            error={errors.secondZipcode}
            disabled={isEdit}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;
